import { makeStyles } from '@material-ui/core';

// Иконка в свёрнутом сайдбаре: монограмма W в скруглённом квадрате.
// Готового знака wilde.tech в векторе нет (регистрация ТЗ идёт), поэтому знак
// типографический — заменить на настоящий, когда появится SVG от дизайнера.
const useStyles = makeStyles(theme => ({
  svg: {
    width: 'auto',
    height: 28,
  },
  box: {
    fill: theme.palette.primary.main,
  },
  glyph: {
    fill: theme.palette.getContrastText(theme.palette.primary.main),
  },
}));

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
      <rect className={classes.box} width="48" height="48" rx="11" />
      <path
        className={classes.glyph}
        d="M9 15h5.4l3.3 12.6L21.3 15h5.4l3.6 12.6L33.6 15H39l-6 18h-5.7L24 21.6 20.7 33H15L9 15z"
      />
    </svg>
  );
};
